import { INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_REQUEST, INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_SUCCESS } from '../actions';
export const photoCaptureIntelligentReactivationUrlDetailsReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, companyCode: action.payload.coCode, contextId: action.payload.contextId });
        case INTELLIGENT_PHOTO_CAPTURE_GET_REACTIVATION_URL_DATA_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isLoading: false, downloadArtifactAuthDetailsInfo: {
                    reactivateAllowed: false,
                    downloadAllowed: true,
                    downloadLinkExpired: false
                } });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentReactivationUrlDetailsReducer.js.map